import { ErrorToast, SuccessToast } from "../components/toastify";
import { AxiosPostMethod } from "../helpers/customAxios";
import { setShowPreloader } from "../store/activePage";
import { setUserLoginStatus } from "../store/userStatus";

const HandleLogin = async (dispatch, navigate, data) => {
  dispatch(setShowPreloader(true)); // Show preloader before API call
  const loginres = await AxiosPostMethod("customer/login", data, true);
  dispatch(setShowPreloader(false)); // Show preloader before API call
  if (loginres?.status === 403) {
    console.log("inside set token");
    localStorage.setItem("dwt-tok-otp", loginres.data.data.access_token);
    navigate("/verify-mobile");
  } else if (loginres?.status === 200) {
    dispatch(setUserLoginStatus(true));
    console.log("loginres", loginres.data.data.user_info);
    localStorage.setItem("phone_number", loginres.data.data.user_info.mobile);
    localStorage.setItem(
      "customer-name",
      `${loginres.data.data.user_info.first_name} ${loginres.data.data.user_info.last_name}`
    );
    localStorage.setItem("dwt-cust-tok", loginres.data.data.access_token);
    navigate("/dashboard/home");
    SuccessToast("Welcome Back!");
  } else {
    ErrorToast("Username or Password Incorrect");
  }
};

export default HandleLogin;
